import React from "react";
import Card from "../Card";
export default function Body() {
  const datos = [
    {
      url: "https://cdn.pixabay.com/photo/2016/11/14/17/39/person-1824144_960_720.png ",
      name: "name",
      descripcion:
        "Motter se mudó a Nueva York en 1990, donde actuó como director artístico y diseñador",
    },
    {
      url: "https://cdn.pixabay.com/photo/2016/11/14/17/39/person-1824144_960_720.png ",
      name: "name",
      descripcion:
        "Motter se mudó a Nueva York en 1990, donde actuó como director artístico y diseñador",
    },
    {
      url: "https://cdn.pixabay.com/photo/2016/11/14/17/39/person-1824144_960_720.png",
      name: "name",
      descripcion:
        "Motter se mudó a Nueva York en 1990, donde actuó como director artístico y diseñador",
    },
  ];

  return (
    <div className="flex flex-col mx-5 ">
      <div className="flex flex-row justify-center">
        <div className="m-5 w-2/5">
          <h2 className="text-3xl font-semibold text-purple-700"> Años Siguientes </h2>
          <p className="text-xl">
            Motter se mudó a Nueva York en 1990, donde actuó como director
            artístico y diseñador jefe para Byron Preiss Visual
            Publications(para quienes también editó una línea de novelas
            gráficas protagonizadas por Philip Marlowe).En 1993, se incorporó al
            equipo creativo de DC Comics, donde supervisó los diseños
            corporativos y licenciatarios de muchos de sus personajes.Volvió a
            la comunidad freelance en 1997, manteniendo a sus antiguos
            empleadores entre sus clientes más activos.La aclamada serie,
            escrita por Motter y dibujada por Michael Lark para la línea
            Vertigo, Terminal City, y su secuela Terminal City: Aerial Graffiti,
            fueron nominadas a varios Premios Eisner y Premios Harvey durante su
            publicación(1996– 1998) Sus dibujos han aparecido en muchos
            cómics, notablemente en la adaptación de Classics Illustrated de The
            Rime of the Ancient Mariner, Batman: Gotham Knights, Grendel: Red,
            White and Black, John Constantine: Hellblazer y Artists
            Respond, así como en el libro para niños Superman 's First Flight,
            para Scholastic.Ha escrito historias para Superman Adventures, Star
            Wars Tales, Will Eisner ' s The Spirit, y Wolverine En 2001,
            Motter se reunió con Michael Lark para crear la galardonada novela
            gráfica Batman: Nueve vidas para DC Comics.Durante esta época
            también escribió e ilustró Electropolis para Image Comics. Motter ha
            compilado y diseñado las retrospectivas Echoes: The Drawings of
            Michael Wm.Kaluta y The Thrilling Comic Book Cover Art of Alex
            Schomberg para Vanguard Productions, así como Mister X: The
            Archives(que incluye las reminiscencias de Motter y un nuevo final
            ilustrado) para Dark Horse Books.
          </p>
        </div>
        <div className="m-5 ml-32 w-2/5">
          <h2 className="text-3xl font-semibold text-purple-700"> Obra de Dean Motter </h2>
          <li> Clasicos Ilustrados </li>
          <li> Batman </li>
          <li> Hellblazer </li>
          <li> Grendel </li>
          <li> Aventuras de Superman </li>
          <li>Cuentos de Star Wars</li>
        </div>
      </div>

      <div className="flex flex-row">
        <Card datos={datos} />
      </div>
    </div>
  );
}
